import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import Header from '../components/layout/Header'
import Footer from '../components/layout/Footer'
import { FaArrowRight } from 'react-icons/fa'
import { Helmet } from 'react-helmet'
import { Share } from 'react-bootstrap-icons'
import { WhatsappIcon, FacebookIcon } from 'react-share'

// Import images
import BannerImg from '../assets/images/banners/Banner1.webp'
import axios from 'axios'
import { Calendar3, Clock, GeoAlt } from 'react-bootstrap-icons'

const Events = () => {
    const [events, setEvents] = useState([])
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState(null)
    const [currentPage, setCurrentPage] = useState(1)
    const [activeShareDropdown, setActiveShareDropdown] = useState(null)
    const eventsPerPage = 9

    const copyToClipboard = async (url) => {
        try {
            await navigator.clipboard.writeText(url)
            alert('Link copied to clipboard!')
        } catch (err) {
            console.error('Failed to copy:', err)
        }
        setActiveShareDropdown(null)
    }

    const toggleShareDropdown = (index) => {
        setActiveShareDropdown(activeShareDropdown === index ? null : index)
    }

    useEffect(() => {
        axios
            .get(`${process.env.REACT_APP_API_URL}/events/website`)
            .then((response) => {
                // Sort events by from_date in descending order (latest first)
                const sortedEvents = response.data.events.sort((a, b) => {
                    return new Date(b.from_date) - new Date(a.from_date)
                })
                setEvents(sortedEvents)
                setLoading(false)
            })
            .catch((error) => {
                console.error('Error fetching events:', error)
                setError('Failed to load events.')
                setLoading(false)
            })
    }, [])

    const formatDate = (dateStr) => {
        const options = { year: 'numeric', month: 'short', day: 'numeric' }
        return new Date(dateStr).toLocaleDateString(undefined, options)
    }

    const formatTime = (timeStr) => {
        const [hour, minute] = timeStr.split(':')
        const date = new Date()
        date.setHours(hour, minute)
        return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
    }
    // Calculate pagination
    const indexOfLastEvent = currentPage * eventsPerPage
    const indexOfFirstEvent = indexOfLastEvent - eventsPerPage
    const currentEvents = events.slice(indexOfFirstEvent, indexOfLastEvent)
    const totalPages = Math.ceil(events.length / eventsPerPage)

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber)
        window.scrollTo(0, 0)
    }

    return (
        <>
            <Helmet>
                <meta charSet="utf-8" />
                <title>Dubai Real Estate Events | Property Exhibitions & Investment Forums</title>
                <meta
                    name="description"
                    content="Attend 800 Homes exclusive Dubai property events worldwide. Our real estate exhibitions showcase premium Dubai properties and investment opportunities with expert-led sessions."
                />

                <meta property="og:type" content="website" />
                <meta
                    property="og:title"
                    content="Dubai Real Estate Events | Property Exhibitions & Investment Forums"
                />
                <meta
                    property="og:description"
                    content="Attend 800 Homes exclusive Dubai property events worldwide. Our real estate exhibitions showcase premium Dubai properties and investment opportunities with expert-led sessions."
                />
                <meta property="og:url" content="https://800homes.ae/" />
                <meta property="og:site_name" content="800homes" />
                <meta property="og:image" content="https://800homes.ae/og.webp" />
                <meta property="og:image:width" content="1200" />
                <meta property="og:image:height" content="630" />
                <meta property="og:image:secure_url" content="https://800homes.ae/og.webp" />

                <meta name="twitter:card" content="summary_large_image" />
                <meta
                    name="twitter:description"
                    content="Attend 800 Homes exclusive Dubai property events worldwide. Our real estate exhibitions showcase premium Dubai properties and investment opportunities with expert-led sessions."
                />
                <meta
                    name="twitter:title"
                    content="Dubai Real Estate Events | Property Exhibitions & Investment Forums"
                />
                <meta name="twitter:image" content="https://800homes.ae/og.webp" />
                <link rel="canonical" href="https://800homes.ae/events/" />
            </Helmet>
            <Header />

            {/* Banner Section */}
            <section
                id="website-responsive"
                className="container-fluid common-banner shadow-800homes"
                style={{ backgroundImage: `url(${BannerImg})` }}
            >
                <div className="row justify-content-center align-items-center">
                    <div className="col-11 col-lg-10">
                        <h1 className="lh-sm fw-600 banner-title text-uppercase text-white text-center">Events</h1>
                        <div></div>
                    </div>
                </div>
            </section>

            <section className="pt-5 mt-md-5" />
            {loading && <p className="text-center">Loading events...</p>}
            {error && <p className="text-center text-danger">{error}</p>}
            {/* Events Section */}
            {!loading && !error && (
                <section className="py-md-5">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-11 col-md-10 mx-auto">
                                <div className="row">
                                    {currentEvents.length === 0 ? (
                                        <div className="text-center text-white py-5">
                                            <h3>No Upcoming Events</h3>
                                        </div>
                                    ) : (
                                        currentEvents.map((event, index) => {
                                        const eventUrl = `${window.location.origin}/events/${event?.slug}`
                                        return (
                                            <div key={event._id} className="col-md-6 col-lg-4 mb-5">
                                                <div className="card h-100 shadow hover-scale transition-300 border-0 rounded-3 overflow-hidden">
                                                    <div className="card-body p-0 d-flex flex-column">
                                                        <div className="position-relative">
                                                            <img
                                                                src={event.image}
                                                                alt={event.title}
                                                                className="img-fluid event-img"
                                                                style={{
                                                                    width: '100%',
                                                                    height: '250px',
                                                                    objectFit: 'cover',
                                                                }}
                                                            />
                                                            <div className="position-absolute top-0 end-0 m-2">
                                                                <button
                                                                    className="btn btn-sm text-white border-0 bg-transparent"
                                                                    onClick={() => toggleShareDropdown(index)}
                                                                    style={{ padding: '4px' }}
                                                                >
                                                                    <Share size={20} />
                                                                </button>
                                                                {activeShareDropdown === index && (
                                                                    <div className="position-absolute end-0 top-100 mt-2 bg-dark border border-white rounded-1 p-2 z-10">
                                                                        <div className="d-flex flex-column gap-2">
                                                                            <a
                                                                                href={`https://api.whatsapp.com/send?text=${encodeURIComponent(event?.title + ' ' + eventUrl)}`}
                                                                                className="d-flex align-items-center text-white text-decoration-none"
                                                                                target="_blank"
                                                                                rel="noreferrer"
                                                                            >
                                                                                <WhatsappIcon size={24} round />
                                                                                <span className="ms-2 fs-ss-14">WhatsApp</span>
                                                                            </a>
                                                                            <a
                                                                                href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(eventUrl)}`}
                                                                                className="d-flex align-items-center text-white text-decoration-none"
                                                                                target="_blank"
                                                                                rel="noreferrer"
                                                                            >
                                                                                <FacebookIcon size={24} round />
                                                                                <span className="ms-2 fs-ss-14">Facebook</span>
                                                                            </a>
                                                                            <button
                                                                                className="btn btn-sm btn-outline-light d-block align-items-center text-center"
                                                                                onClick={() => copyToClipboard(eventUrl)}
                                                                            >
                                                                                <div className="fs-ss-14">Copy Link</div>
                                                                            </button>
                                                                        </div>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>
                                                        <div className="p-4 flex-grow-1">
                                                            <div className="event-date-container">
                                                                <div className="d-flex align-items-center">
                                                                    <div>
                                                                        <div className="mb-0 small text-ss-secondary d-flex align-items-start flex-column">
                                                                            <h4 className="fs-ss-20 fw-600 mb-3 text-ss-secondary align-text-line2 mb-4">
                                                                                {event.title}
                                                                            </h4>
                                                                            <div className="d-flex align-items-start">
                                                                                <Calendar3
                                                                                    className="me-2"
                                                                                    style={{ marginTop: '2px' }}
                                                                                    size={14}
                                                                                />
                                                                                <div>
                                                                                    {event.occurrence ===
                                                                                    'recurring' ? (
                                                                                        event.recurrence_days?.length >
                                                                                            0 && (
                                                                                            <>
                                                                                                <span className="fw-700">
                                                                                                    Recurring on every:
                                                                                                </span>{' '}
                                                                                                {event.recurrence_days.join(
                                                                                                    ', ',
                                                                                                )}
                                                                                            </>
                                                                                        )
                                                                                    ) : (
                                                                                        <>
                                                                                            {event.type ===
                                                                                                'single' && (
                                                                                                <>
                                                                                                    <span className="fw-700">
                                                                                                        Date:
                                                                                                    </span>{' '}
                                                                                                    {formatDate(
                                                                                                        event.from_date,
                                                                                                    )}
                                                                                                </>
                                                                                            )}
                                                                                            {event.type === 'multi' && (
                                                                                                <>
                                                                                                    <span className="fw-700">
                                                                                                        Date:
                                                                                                    </span>{' '}
                                                                                                    {formatDate(
                                                                                                        event.from_date,
                                                                                                    )}{' '}
                                                                                                    -{' '}
                                                                                                    {formatDate(
                                                                                                        event.to_date,
                                                                                                    )}
                                                                                                </>
                                                                                            )}
                                                                                        </>
                                                                                    )}
                                                                                </div>
                                                                            </div>
                                                                            <div className="py-2">
                                                                                <div className="d-flex align-items-start">
                                                                                    <Clock
                                                                                        className="me-2"
                                                                                        style={{ marginTop: '2px' }}
                                                                                        size={14}
                                                                                    />
                                                                                    <div>
                                                                                        {event.from_time && (
                                                                                            <div>
                                                                                                <span className="fw-700">
                                                                                                    Time:
                                                                                                </span>{' '}
                                                                                                {formatTime(
                                                                                                    event.from_time,
                                                                                                )}
                                                                                                {event.to_time
                                                                                                    ? ` - ${formatTime(
                                                                                                          event.to_time,
                                                                                                      )}`
                                                                                                    : ''}
                                                                                            </div>
                                                                                        )}
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <div className="mb-0 small text-ss-secondary d-flex align-items-start">
                                                                            <div className="">
                                                                                <GeoAlt
                                                                                    className="me-2"
                                                                                    style={{ marginTop: '2px' }}
                                                                                    size={14}
                                                                                />
                                                                            </div>
                                                                            <div>{event.venue_address}</div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="bg-white border-0 pt-0 pb-4 px-4 mt-auto">
                                                        <Link
                                                            to={`/events/${event.slug}`}
                                                            className="btn fs-ss-14 bg-ss-primary bg-hover-ss-primary2 text-white d-flex align-items-center justify-content-between"
                                                        >
                                                            <span>View Event Details</span>
                                                            <FaArrowRight />
                                                        </Link>
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    })
                                    )}
                                </div>

                                {events.length > eventsPerPage && (
                                    <div id="events" className="d-flex justify-content-center mt-5">
                                        <nav aria-label="Page navigation">
                                            <ul className="pagination">
                                                {Array.from({ length: totalPages }, (_, i) => i + 1).map((number) => (
                                                    <li
                                                        key={number}
                                                        className={`page-item ${
                                                            currentPage === number ? 'active' : ''
                                                        }`}
                                                    >
                                                        <button
                                                            className={`page-link ${
                                                                currentPage === number
                                                                    ? 'bg-ss-primary border-ss-primary'
                                                                    : 'text-ss-primary'
                                                            }`}
                                                            onClick={() => handlePageChange(number)}
                                                        >
                                                            {number}
                                                        </button>
                                                    </li>
                                                ))}
                                            </ul>
                                        </nav>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </section>
            )}

            <Footer />
        </>
    )
}

export default Events
